import Fuse from "fuse.js";

const THRESHOLD = 0.2;

/**
 * The purpose of this function is to allow client-side searching of
 * teams.
 *
 * We use the Fuse library to filter results by the search term.
 */
const getSearchResults = (searchTerm, searchFields, allData) => {
	const options = {
		threshold: THRESHOLD,
		includeScore: false,
		keys: searchFields,
	};

	const fuse = new Fuse(allData, options);

	const result = fuse.search(searchTerm);

	return result;
};

export default getSearchResults;
